import React from "react";

export default function UserTermsConditions() {
  // const sections = [
  //   {
  //     title: "1. About INRYDE",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>INRYDE is a technology platform connecting Customers with Riders.</li>
  //         <li>INRYDE does not own vehicles or employ Riders.</li>
  //         <li>Ride services are provided directly by Riders as independent operators.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "2. User Registration & Account Usage",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Customer must provide accurate personal details during signup.</li>
  //         <li>Customer is responsible for protecting their login credentials.</li>
  //         <li>Account sharing, impersonation, or using fraudulent information is prohibited.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "3. Booking, Ride Conduct & Responsibilities",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Provide accurate pickup and drop-off details.</li>
  //         <li>Maintain respectful behaviour with Riders.</li>
  //         <li>Not carry harmful items, drugs, weapons, illegal goods, or hazardous substances.</li>
  //         <li>Wear helmet (for bike rides) and seat belt (for cars).</li>
  //         <li>Avoid forcing Riders to violate traffic rules or take unsafe routes.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "4. Payments & Charges",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Customer agrees to pay the full fare including GST, tolls, peak charges, and applicable fees.</li>
  //         <li>Fare estimates may vary based on distance, time, and traffic.</li>
  //         <li>Refund/payment disputes will be handled by INRYDE support.</li>
  //         <li>INRYDE may deduct cancellation fees for repeated or late cancellations.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "5. Cancellation Policy",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Cancellation fees apply if a Rider has reached or is close to pickup.</li>
  //         <li>Fees may apply for repeated cancellations or unnecessary delays.</li>
  //         <li>No fee applies if cancellation is due to Rider misconduct upon verification.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "6. Ratings & Feedback",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Customers must provide fair and honest ratings.</li>
  //         <li>Abusive, false, or defamatory reviews are prohibited.</li>
  //         <li>Harassment of Riders may lead to account suspension.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "7. Lost Items & Personal Property",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>INRYDE is not responsible for loss of personal belongings.</li>
  //         <li>Lost items must be reported via app or customer support.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "8. Privacy & Data Usage",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>INRYDE may collect personal data for safety, operations, and analytics.</li>
  //         <li>Data may be shared with authorities in legal/safety cases.</li>
  //         <li>INRYDE does not sell user data without consent.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "9. Liability Disclaimer",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>INRYDE is not responsible for delays due to traffic, weather, or breakdowns.</li>
  //         <li>Not liable for injuries caused by refusal to wear helmets/seatbelts.</li>
  //         <li>Not liable for unsafe actions by Customers.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "10. Prohibited Actions",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Abusive behaviour, harassment, discrimination.</li>
  //         <li>Fake bookings or fraudulent payments.</li>
  //         <li>Transporting harmful or illegal goods.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "11. Termination / Account Suspension",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Accounts may be suspended for violating T&Cs.</li>
  //         <li>Fraud, harassment, or illegal activities may lead to termination.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "12. Governing Law & Dispute Resolution",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Governed by Indian law.</li>
  //         <li>15 days of amicable resolution required before arbitration.</li>
  //         <li>Arbitration seat: City specified by INRYDE HQ.</li>
  //         <li>Proceedings in English; award is final.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "13. Policy Updates",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
  //         <li>Changes may be communicated via notifications, SMS, or email.</li>
  //         <li>Continued use implies acceptance of new terms.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "14. Contact",
  //     content: (
  //       <p style={{ color: "#6C757D" }}>
  //         For queries, email <a href="mailto:support@inryde.in" style={{ color: "#E63946", textDecoration: "underline" }}>support@inryde.in</a>
  //       </p>
  //     ),
  //   },
  // ];

  const sections = [
  {
    title: "1. Content Updates",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>The content of this website is subject to change without prior notice.</li>
      </ul>
    ),
  },

  {
    title: "2. Accuracy & Warranty Disclaimer",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>No warranty or guarantee is provided regarding accuracy, timeliness, performance, completeness or suitability of any information.</li>
        <li>The website content may contain errors or inaccuracies.</li>
        <li>We expressly exclude liability for such inaccuracies to the fullest extent permitted by law.</li>
      </ul>
    ),
  },

  {
    title: "3. User Responsibility & Risks",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>Use of website information is entirely at the user’s own risk.</li>
        <li>User must ensure services/products meet their specific requirements.</li>
        <li>We shall not be liable for loss or damage arising from use of this website.</li>
      </ul>
    ),
  },

  {
    title: "4. Intellectual Property & Copyright",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>All materials including layout, design, graphics and appearance are owned or licensed to us.</li>
        <li>Reproduction is prohibited except in accordance with copyright permissions.</li>
        <li>Trademarks not owned or licensed by us are acknowledged on the website.</li>
      </ul>
    ),
  },

  {
    title: "5. Unauthorized Usage",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>Unauthorized use of website information may result in claims for damages and/or criminal prosecution.</li>
      </ul>
    ),
  },

  {
    title: "6. External Website Links",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>External links may be provided for additional information and convenience.</li>
        <li>We are not responsible for content on linked websites.</li>
        <li>Creating a link to this website without prior written consent is prohibited.</li>
      </ul>
    ),
  },

  {
    title: "7. Dispute & Governing Laws",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>Any dispute related to use of this website or engagements with us is governed by the laws of India.</li>
      </ul>
    ),
  },

  {
    title: "8. Declined Payment Authorization",
    content: (
      <ul style={{ color: "#6C757D", paddingLeft: "20px", listStyleType: "none" }}>
        <li>We shall not be liable for losses caused due to declined transaction authorization.</li>
        <li>Declines may occur if preset limits agreed with card issuing/acquiring bank are exceeded.</li>
      </ul>
    ),
  },
];


  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "50px",
          textAlign: "center",
        }}
      >
        User Terms and Conditions
      </h1>

      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#E63946",
              borderBottom: "3px solid #E63946",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          {section.content}
        </div>
      ))}
    </div>
  );
}
